/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Security_Totp_NextInputs */



/**
* | output |
* | --- |
* | "Continue" |
*
* @param {Profile_Security_Totp_NextInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const profile_security_totp_next = /** @type {((inputs?: Profile_Security_Totp_NextInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Security_Totp_NextInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Weiter")
	return /** @type {LocalizedString} */ ("Continue")
});